import { createEvent, createStore } from 'effector'

export const openMediaCategory = createEvent('open media category')
export const closeMediaCategory = createEvent('close media category')
export const $isCategoryMediaOpen = createStore(false, {
  name: 'is category media open',
})
  .on(openMediaCategory, () => true)
  .reset(closeMediaCategory)

export const openVault = createEvent('open vault')
export const closeVault = createEvent('close vault')
export const $isVaultOpen = createStore(false, {
  name: 'is vault open',
})
  .on(openVault, () => true)
  .reset(closeVault)
